const { scrollmagic } = require("./modules/scrollmagic");
const { pageTop } = require("./modules/pageTop");
const { smooth } = require("./modules/smooth");
const { tab } = require("./modules/tab");
const { opener } = require("./modules/opener");
const { modal } = require("./modules/modal");
const { mvAnime } = require("./modules/mvAnime");

scrollmagic();
pageTop();
smooth();
tab();
opener();
modal();
mvAnime();